<template>
  <div class="footer">
    <div class="container">
        <div class="row pt-5 pb-5 halfheight">
            <div class="col-10 col-sm-6 col-md-6 col-lg-12 d-flex">
                <div class="row">
                    <div class="col-12">
                         <router-link tag="a" to="/" class="navbar-brand white-frame"><img @click="scrollToTop" class="logo" src="~@/assets/images/logo.png"></router-link>
                    </div>
                    <div class="col-lg-3 ml-auto mr-auto">
                        <h6 class="mt-4 title" style="text-transform: uppercase;">{{ $t('foot.vision') }}</h6>
                        <div class="mt-3 col-12 content pl-0 pr-0">{{ $t('foot.content') }}</div>
                        <div class="icon mt-3">
                            <span class="mr-3"><a href=""><i class="fab fa-facebook-square"></i></a></span>
                            <span class="mr-3"><a href=""><i class="fab fa-line"></i></a></span>
                            <span class="mr-3"><a href=""><i class="fab fa-twitter-square"></i></a></span>
                            <span class="mr-3"><a href=""><i class="fab fa-github-square"></i></a></span>
                        </div>
                    </div>
                    <div class="col-lg-2 offset-1">
                        <h6 class="mt-4 title">{{ $t('foot.company') }}</h6>
                        <div class="mt-3 content">
                            <ul v-html="$t('foot.ul1')">
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <h6 class="mt-4 title">{{ $t('foot.features') }}</h6>
                        <div class="mt-3 content">
                            <ul v-html="$t('foot.ul2')">
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <h6 class="mt-4 title">{{ $t('foot.contact') }}</h6>
                        <div class="mt-3 content">
                            <ul v-html="$t('foot.ul3')">
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bg">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <span>Copyright © New IT Corporation 2019-2020. All Right Reserved</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  methods: {
    scrollToTop () {
      $('html, body').animate({
        scrollTop: 0
      }, 800)
      return false
    }
  }
}
</script>
